import { actions } from '@kanda-libs/ks-frontend-services';
import { useAppDispatch } from 'components/App';
import { useCurrentJob } from 'hooks';
import useApiError from 'hooks/useApiError';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectors } from 'store';

/**
 * Hook for resending the job email for the job locked out modal
 * @returns {{onResendJob: ((function(): void)|*), isSubmitting: boolean}}
 */
export default function useEmailResend() {
  const dispatch = useAppDispatch();
  const isSubmitting = useSelector(selectors.job.getIsSubmitting);
  const onError = useApiError(
    'There was an error resending the email for this job. Please try again or contact support if the problem persists',
  );

  const { id } = useCurrentJob();
  const [sent, setSent] = useState(false);

  const onResendJob = useCallback(() => {
    if (!id) return;

    dispatch(
      actions.resendJob({
        params: { id },
        onError,
        onSuccess: () => {
          setSent(true);
        },
      }),
    );
  }, [dispatch, id, onError]);

  return {
    sent,
    onResendJob,
    isSubmitting,
  };
}
